import React, { useEffect, useRef, useState } from "react";
import { Button, Space, Row, Table, Spin, Col, TabsProps, Tabs } from "antd";
import "./CustomerList.scss";
import {
  BdPatientColumns,
  backToTheDoctorColumns,
  rejectColumns,
} from "./config";
import { fields as fieldsList } from "./config";
import { remainPatient } from "./config2";
import ExpandSearch from "components/common/ExpandSearch/ExpandSearch";
import { tabKeys } from "types/enums";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import Notification from "components/common/notification/notification";
import { exportFile, formatDateToString } from "helper/common";
import customerCare from "api/customerCare";
import {
  setDataCustomerCare,
  setDataLichSus,
  setIdCustomerCare,
  setIdDatLich,
} from "redux/reducer/customerCare";
import PatientInfo from "../Detail/PatientInfo/PatientInfo";
import { allColumnsLSU, fields } from "../Detail/PatientInfo/config";
import { ListActionButton, ModalCustom } from "components/common";
import RejectPatient from "./ChildTabs/Reject";
import BackToTheDotorPatient from "./ChildTabs/BackToTheDotor";
import dayjs from "dayjs";
import ModalAgree from "./ModalAgree/ModalAgree";
import RemainPatient from "./ChildTabs/RemainPatient";
import BdPatient from "./ChildTabs/BdPatient";

const CustomerList: React.FC = () => {
  const patientRef = useRef<any>();

  const dispatch = useAppDispatch();
  const [loadingLSu, setLoadingLSu] = useState(false);
  const [loadingInfo, setLoadingInfo] = useState(false);
  const [total, setTotal] = useState();
  const dataCustomerCare = useAppSelector(
    (e) => e.customerCare.dataCustomerCare
  );
  const [params, setParams] = useState<any>({
    page: 1,
    limit: 10,
    ngayHenPTTu: dayjs(),
    ngayHenPTDen: dayjs(),
  });
  const lichSus = useAppSelector((e) => e.customerCare.lichSus);
  const [loadingList, setLoadingList] = useState<boolean>(false);
  const [columns, setColumns] = useState(rejectColumns);

  const [data, setData] = useState([]);
  const [paramsLsu, setParamsLSu] = useState<any>({
    page: 1,
    limit: 10,
  });
  const expandRef = useRef<any>();
  const [childTab, setChieldTab] = useState(tabKeys.CUSTOMER_CARE.REJECT);
  const [isDatLichPT, setIsDatLichPT] = useState(true);
  const idCustomerCare = useAppSelector((e) => e.customerCare.idCustomerCare);
  const idDatLich = useAppSelector((e) => e.customerCare.idDatlichPT);
  useEffect(() => {
    getList();
  }, [params, childTab]);

  const onClickSearchButton = () => {
    var searchFields = expandRef.current?.getData();
    setParams({
      ...params,
      ...searchFields,
      page: 1,
    });
  };
  columns.find((e) => (e.dataIndex = "stt")).render = (v, r, i) => {
    const index = (params.page - 1) * params.limit + i + 1;
    return index;
  };

  useEffect(() => {
    getDetailCustomerCare();
  }, [idCustomerCare]);

  //Lưu thông tin
  const handleSave = async () => {
    try {
      const value = await patientRef.current?.getFormValue();

      const newValue = {
        ...value,
        idPhieuKham: dataCustomerCare?.idPhieuKham,
        id: dataCustomerCare?.id,
      };

      await customerCare.updateCustomerCare(idCustomerCare, newValue);

      getDetailCustomerCare();
      getList();
      Notification("success", "Cập nhật dữ liệu thành công");
    } catch (error) {
      Notification("error", "Cập nhật dữ liệu thất bại");
    }
  };

  const getList = async () => {
    setLoadingList(true);
    try {
      const res = await customerCare.getLitCustomerCare(formatParams());
      const newData = res.data.map((item) => {
        return {
          ...item,
          key: item.id,
        };
      });

      setData(newData);
      setTotal(res.total);

      setLoadingList(false);
    } catch (error) {
      setLoadingList(false);
      Notification("error", "Đã có lỗi xảy ra khi tải dữ liệu");
    }
  };
  const fieldsOfPatient = fields();
  const formatParams = () => {
    if (childTab === tabKeys.CUSTOMER_CARE.REJECT) {
      setIsDatLichPT(true);
      setColumns(rejectColumns);

      return {
        ...params,
        ngaySinh: formatDateToString(params.ngaySinh),
        ngayHenPTTu: formatDateToString(params.ngayHenPTTu),
        ngayHenPTDen: formatDateToString(params.ngayHenPTDen),
        loaiCSKH: 1,
        isTaiKham: null,
      };
    } else if (childTab === tabKeys.CUSTOMER_CARE.BACK_TO_THE_DOCTOR) {
      setIsDatLichPT(false);
      // setIsApointemt("block");
      setColumns(backToTheDoctorColumns);

      return {
        ...params,
        ngaySinh: formatDateToString(params.ngaySinh),
        ngayHenPTTu: formatDateToString(params.ngayHenPTTu),
        ngayHenPTDen: formatDateToString(params.ngayHenPTDen),
        loaiCSKH: null,
        isTaiKham: true,
      };
    } else if (childTab === tabKeys.CUSTOMER_CARE.REMAIN_PATIENT) {
      setIsDatLichPT(false);
      // setIsApointemt("block");
      setColumns(remainPatient);

      return {
        ...params,
        ngaySinh: formatDateToString(params.ngaySinh),
        ngayHenPTTu: formatDateToString(params.ngayHenPTTu),
        ngayHenPTDen: formatDateToString(params.ngayHenPTDen),
        loaiCSKH: null,
        isTaiKham: null,
      };
    } else if (childTab === tabKeys.CUSTOMER_CARE.BD_PATIENT) {
      setIsDatLichPT(false);
      setColumns(BdPatientColumns);

      return {
        ...params,
        ngaySinh: formatDateToString(params.ngaySinh),
        ngayHenPTTu: formatDateToString(params.ngayHenPTTu),
        ngayHenPTDen: formatDateToString(params.ngayHenPTDen),
        loaiCSKH: null,
        isTaiKham: null,
        isBirthDay: true,
      };
    }
  };

  //lấy thông tin chi tiết
  const getDetailCustomerCare = async () => {
    if (idCustomerCare !== null) {
      setLoadingInfo(true);
      setLoadingLSu(true);
      try {
        const res = await customerCare.getDetailsCustomerCare(idCustomerCare);
        if (res?.trangThai === 0) {
          const newRes = postStatusDetailCustomerCareForm(1);
          dispatch(setDataCustomerCare(newRes));
        } else dispatch(setDataCustomerCare(res));
        const newLichSus = res.lichSus?.map((item) => {
          return { ...item, key: item.id };
        });
        dispatch(setDataLichSus(newLichSus));
        setLoadingInfo(false);
        setLoadingLSu(false);
      } catch (error) {
        setLoadingInfo(false);
        setLoadingLSu(false);
        ``;
        Notification(
          "error",
          "Đã xảy ra lỗi khi lấy thông tin chi tiết bệnh nhân"
        );
      }
    }
  };

  const onChangePaginationLSu = (page: number, pageSize: number) => {
    setParamsLSu({ ...paramsLsu, page: page, limt: pageSize });
  };
  const handleOnExport = async () => {
    const params = formatParams();
    if (!params.ngayHenPTTu && !params.ngayHenPTDen) {
      Notification("warning", "Chưa chọn thời gian xuất báo cáo");
    } else {
      exportFile(
        "qlkhambenh/phieu-cskh/export-list-phieu-cskh",
        formatParams(),
        "Báo cáo bệnh nhân"
      );
    }
  };
  // Chuyển trạng thái bệnh nhân
  const postStatusDetailCustomerCareForm = async (trangThai, name?) => {
    // setLoading(true);
    try {
      const params = {
        id: idCustomerCare,
        trangThaiCSKH: trangThai,
      };
      const res = await customerCare.updateStatusDetail(params);

      dispatch(setDataCustomerCare(res));

      // setLoading(false);

      if (trangThai !== 2) {
        Notification("success", `Đã cập nhật phiếu thành trạng thái${name}`);
      }
    } catch (error) {
      // setLoading(false);

      Notification("error", "Đã có lỗi xảy ra");
    }
  };
  // Xóa lịch sử khám
  const handleDelete = async (idLsu: number | string) => {
    try {
      await customerCare.deleteDetailsCustomerCare(idLsu);

      getDetailCustomerCare();

      Notification("success", "Xóa thành công");
    } catch (error) {
      Notification("error", "Xóa không thành công");
    }
  };
  //Lịch sử cskh
  allColumnsLSU.map((item) => {
    if (item.dataIndex === "stt") {
      item.render = (t, r, i) => {
        const stt = (paramsLsu.page - 1) * paramsLsu.limit + i + 1;
        return stt;
      };
    }

    if (item.dataIndex == "action") {
      item.render = (t, r: { id: number | string }) => (
        <ListActionButton deleteFunction={() => handleDelete(r.id)} />
      );
    }
  });
  //Tab Child
  const itemsInit: TabsProps["items"] = [
    {
      key: tabKeys.CUSTOMER_CARE.REJECT,
      label: `BN từ chối PT`,
      children: (
        <RejectPatient
          data={data}
          setParams={setParams}
          params={params}
          total={total}
          loading={loadingList}
          childTab={childTab}
          onExportEcel={handleOnExport}
        />
      ),
    },
    {
      key: tabKeys.CUSTOMER_CARE.BACK_TO_THE_DOCTOR,
      label: `BN tái khám`,
      children: (
        <BackToTheDotorPatient
          data={data}
          setParams={setParams}
          params={params}
          total={total}
          loading={loadingList}
          onExportEcel={handleOnExport}
          childTab={childTab}
        />
      ),
    },
    {
      key: tabKeys.CUSTOMER_CARE.REMAIN_PATIENT,
      label: `BN còn lại`,
      children: (
        <RemainPatient
          data={data}
          setParams={setParams}
          params={params}
          total={total}
          loading={loadingList}
          onExportEcel={handleOnExport}
          childTab={childTab}
        />
      ),
    },
    {
      key: tabKeys.CUSTOMER_CARE.BD_PATIENT,
      label: `SN bệnh nhân`,
      children: (
        <BdPatient
          data={data}
          setParams={setParams}
          params={params}
          total={total}
          loading={loadingList}
          onExportEcel={handleOnExport}
          childTab={childTab}
        />
      ),
    },
  ];
  const handleChangeTab = (e: any) => {
    setChieldTab(e);
    dispatch(setDataCustomerCare(undefined));
    dispatch(setDataLichSus(null));
    dispatch(setIdCustomerCare(null));
    dispatch(setIdDatLich(null));
  };
  const modalRef = useRef(null);
  const handleAgree = () => {
    modalRef.current.openModal();
  };

  return (
    <div
      className="customer-list"
      style={{ overflow: "scroll", maxWidth: "screen" }}
    >
      <div className="container">
        <Row gutter={[16, 8]}>
          <ExpandSearch
            ref={expandRef}
            onClickSearch={onClickSearchButton}
            fields={fieldsList()}
            onReset={() => {
              onClickSearchButton();
            }}
            initialValues={params}
          />
        </Row>
      </div>
      <div>
        <Row gutter={[16, 8]}>
          <Col span={12} style={{ paddingLeft: 0 }}>
            <Tabs
              items={itemsInit}
              onChange={(e) => {
                handleChangeTab(e);
              }}
            />
          </Col>

          <Col span={12} style={{ paddingRight: 0 }}>
            <Space
              direction="vertical"
              style={{ width: "100%", overflow: "scroll" }}
            >
              <div className="container">
                <Row justify={"space-between"}>
                  <Col className="header">Thông tin bệnh nhân</Col>
                  <Col>
                    <Row justify={"end"}>
                      <Space>
                        {isDatLichPT && (
                          <Button
                            onClick={handleAgree}
                            className="btn-sub"
                            type="primary"
                            disabled={idDatLich ? false : true}
                          >
                            Đặt lịch hẹn PT
                          </Button>
                        )}
                        <Button
                          type="primary"
                          onClick={handleSave}
                          disabled={idCustomerCare ? false : true}
                        >
                          Lưu
                        </Button>
                      </Space>
                    </Row>
                  </Col>
                </Row>
                <div className="container-main">
                  <Spin spinning={loadingInfo}>
                    <PatientInfo
                      ref={patientRef}
                      dataCustomerCare={dataCustomerCare}
                      childTab={childTab}
                    />
                  </Spin>
                </div>
              </div>
              <div className="container">
                <div className="header">Lịch sử CSKH</div>
                <Table
                  columns={allColumnsLSU}
                  dataSource={lichSus}
                  loading={loadingLSu}
                  bordered
                  scroll={{ x: "100%" }}
                  pagination={{
                    position: ["bottomRight"],
                    showSizeChanger: true,
                    current: paramsLsu.page,
                    onChange: onChangePaginationLSu,
                  }}
                />
              </div>
            </Space>
          </Col>
        </Row>
      </div>
      <ModalCustom title="Đặt lịch phẫu thuật" ref={modalRef}>
        <ModalAgree getList={getList} params={params} />
      </ModalCustom>
    </div>
  );
};

export default CustomerList;
